export default theme => ({
  userMenuText: {
    fontSize: 15,
    margin: 0,
  },
});
